/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/system-organisation.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import i18n from 'i18next';
import { AuditActionType } from 'types/graphql-global-types';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getProcessedFieldChangeItems, getFieldChangeItems } from 'views/pages/admin/audit-log/service';

const ProtocolDocumentRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem, record }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
    };
    const refactoredNewRecord = {
        ...newRecord,
    };

    const enums: any = {
        Status: AuditEnumValues.ProtocolDocumentStatuses,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
        }),
    );

    // On upload, the audit record only carries Status, so surface the document name + version from the history item
    if (record?.action === AuditActionType.ADD && newItem?.documentName) {
        items.unshift({
            field: i18n.t('auditLog:field-ProtocolDocument'),
            oldValue: null,
            newValue: newItem.version ? `${newItem.documentName}_${newItem.version}` : newItem.documentName,
        });
    }

    return <FieldChangeGrid items={items} />;
};

export { ProtocolDocumentRecordChangeGrid };
